<template>
  <div name="pupiladd" class="-mx-3 mt-2">
    <section v-if="errored" class="w-full text-center mt-2">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the pupil details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>
    <transition name="fade">
        <div class="loading" v-show="loading">
          <span class="fa fa-spinner fa-spin"></span> Loading
        </div>
      </transition>
      <transition name="fade">
        <div class="loading" v-show="isSaving">
          <span class="fa fa-spinner fa-spin"></span> Saving replies
        </div>
      </transition>
      

    <div class="overflow-y-auto pt-2" v-if="componentLoaded">
      <!-- <h4 v-if="hasFeeling" class="px-4 -mt-4 mb-12 font-bold text-gray-600">Feeling recorded on: <span class="text-black">{{ postedOn }}</span> </h4> -->

      <section class="mx-auto w-11/12 text-left mb-4">
        <div
          class="flex flex-col mb-4"
          v-for="object in questions"
          :key="object.identifier"
        >
          <div class="flex">
            <div class="mr-2 text-base font-semibold">
              {{ object.display_order }}.
            </div>
            <div class="text-base font-semibold text-gray-700">
              {{ parseContent(object.question.content) }}
            </div>
          </div>
          <Poll
            v-if="isPoll(object.question.question_type)"
            :answers="object.answers"
            :selectedAnswers="getAnswersForQuestion(object)"
            @answerSelected="setAnswer"
          ></Poll>
          <PollEmoji
            v-else-if="isPollEmoji(object.question.question_type)"
            :answers="object.answers"
            :selectedAnswers="getAnswersForQuestion(object)"
            @answerSelected="setAnswer"
          ></PollEmoji>
        </div>
      </section>

      <section class="w-11/12 px-3 py-8 mb-12 border-t">
        <div class="w-full mt-2">
          <button
            @click="submitForm()"
            type="button"
            :disabled="isDisabled"
            class="h-10 publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"
          >
            Save your information
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { WellbeingService } from "@/services/wellbeing.service";
import { calendarYearList } from "@/assets/js/utils";

const Poll = () => import("@/components/selfassess/answers/Poll.vue");
const PollEmoji = () => import("@/components/selfassess/answers/PollEmoji.vue");

const POLL = "poll",
  POLL_EMOJI = "poll_emoji";

export default {
  name: "feeling",
  props: {
    course: { type: Object, required: true },
    pupil: { type: Object, required: true },
    survey: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.loading === false;
    },
    isDisabled() {
      return this.setAnswers.length === 0;
    },
    answerReplies() {
      return this.setAnswers;
    },
    // postedOn() {
    //   return  moment(this.feeling.modified_date).format('Do MMMM YYYY');
    // },
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      loading: true,
      isSaving: false,
      isComplete: false,
      questions: [],
      comment: "",
      setAnswers: [],
    };
  },
  created() {},
  mounted() {
    this.getSurveyQuestions();
    this.getSurveyReplies();
  },
  methods: {
    getSurveyQuestions() {
      WellbeingService.getSurveyQuestions(this.survey)
        .then((response) => (this.questions = response.data.data))
        .catch((err) => {
          console.log("Surveys " + err);
          this.errored = true;
        });
    },
    getSurveyReplies() {
      WellbeingService.getPupilUnitSurveyReplies(
        this.pupil,
        this.course.id,
        this.survey
      )
        .then((response) => this.parseReplies(response.data.data))
        .catch((err) => {
          console.log("replies " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    parseReplies(data) {
      this.setAnswers = data;
    },
    parseContent(content) {
      return content.replace("{{course_name}}", this.course.name);
    },
    isPoll(type) {
      return type.key_value === POLL;
    },
    isPollEmoji(type) {
      return type.key_value === POLL_EMOJI;
    },
    setAnswer(object) {
      let found = this.setAnswers.find((aa) => {
        return (
          object.survey_answer.wb_survey_question_identifier ===
          aa.survey_answer.wb_survey_question_identifier
        );
      });

      if (found) {
        found.survey_answer = object.survey_answer;
      } else {
        this.setAnswers.push(object);
      }
    },
    completion() {
      this.isSaving = false
      this.$emit("surveySet");
    },
    failure(error) {
      this.isSaving = false
      this.errored = true;
      console.log("survey update error " + error);
    },
    contentImage(object) {
      return require("@/assets/images/selfassess/icons/" +
        object.answer +
        ".png");
    },
    getAnswersForQuestion(object) {
      let results = this.setAnswers.filter((aa) => {
        return (
          object.identifier === aa.survey_answer.wb_survey_question_identifier
        );
      });
      // console.log(object.identifier, JSON.stringify(results))
      return results;
    },
    submitForm() {
      let calendarYear = calendarYearList().find((y) => y.current === true);
      let vm = this;
      this.isSaving = true;

      vm.setAnswers.forEach(function (aa, index) {
        var payload = {
          content: aa.survey_answer.answer.content,
          wb_survey_answer_identifier: aa.survey_answer.identifier,
          calendar_schoolyear: calendarYear.value,
          notes: "",
          register_identifier: vm.pupil.identifier,
          course_id: vm.course.id,
        };

        if (aa.identifier != undefined) {
          payload.identifier = aa.identifier;
          WellbeingService.updateReply(payload)
            .then((response) => {
              if (index == vm.setAnswers.length - 1) {
                vm.completion();
              }
            })
            .catch((err) => {
              vm.failure(err);
            });
        } else {
          WellbeingService.addReply(payload)
            .then((response) => {
              if (index == vm.setAnswers.length - 1) {
                vm.completion();
              }
            })
            .catch((err) => {
              vm.failure(err);
            });
        }
      });
    },
  },
  components: {
    PollEmoji,
    Poll,
  },
};
</script>

<style scoped>
.feeling-box {
  @apply h-32 w-32 transform rotate-45 rounded-3xl uppercase font-bold;
}

.happy-bg {
  background-color: rgb(208, 154, 226, 0.2);
  color: #d09ae2;
}

.happy-bg.on {
  border-color: #d09ae2;
  border-width: 1px;
}

.excited-bg {
  background-color: rgb(219, 154, 94, 0.2);
  color: rgb(219, 154, 94, 0.9);
}

.excited-bg.on {
  border-color: #db9a5e;
  border-width: 1px;
}

.loved-bg {
  background-color: rgb(224, 119, 160, 0.2);
  color: rgb(224, 119, 160, 0.5);
}

.loved-bg.on {
  border-color: #e077a0;
  border-width: 1px;
}

.okay-bg {
  background-color: rgb(175, 175, 175, 0.2);
  color: rgb(175, 175, 175, 0.9);
}

.okay-bg.on {
  border-color: #afafaf;
  border-width: 1px;
}

.bored-bg {
  background-color: rgb(147, 154, 193, 0.2);
  color: rgb(147, 154, 193, 0.5);
}

.bored-bg.on {
  border-color: #939ac1;
  border-width: 1px;
}

.sad-bg {
  background-color: rgb(105, 139, 188, 0.2);
  color: rgb(105, 139, 188, 0.5);
}

.sad-bg.on {
  border-color: #698bbc;
  border-width: 1px;
}

.angry-bg {
  background-color: rgb(196, 101, 101, 0.2);
  color: rgb(196, 101, 101, 0.9);
}

.angry-bg.on {
  border-color: #c46565;
  border-width: 1px;
}

/* 
Bored - #

Sad - #

Angry - #

Loved - #

Excited - #

Crying - #749aa3 */
</style>